import { Link } from "react-router-dom";

const serviceLinks = [
  { label: "Roof Repair", href: "/services/roof-repair" },
  { label: "Roof Replacement", href: "/services/roof-repair" },
  { label: "Storm Damage Repair", href: "/services/roof-repair" },
  { label: "Roof Inspections", href: "/services/roof-repair" },
  { label: "Leak Detection", href: "/services/roof-repair" },
];

const companyLinks = [
  { label: "About Us", href: "/about" },
  { label: "Service Areas", href: "/locations/colorado-springs" },
  { label: "Brevard County", href: "/locations/colorado-springs" },
  { label: "Volusia County", href: "/locations/colorado-springs" },
];

const offices = [
  {
    region: "Orange",
    address: "924 West Colonial Dr.\nOrlando, FL 32804",
    phone: "(407) 408-0577",
    tel: "407-408-0577",
    mapUrl: "https://www.google.com/maps/place/Thomas+Roofing+%26+Repair/data=!4m2!3m1!1s0x0:0xc54bf8979a5e6371",
  },
  {
    region: "Brevard",
    address: "323 S Washington Ave Suite 14\nTitusville, FL 32796",
    phone: "(321) 291-8292",
    tel: "321-291-8292",
    mapUrl: "https://www.google.com/maps/place/Thomas+Roofing+and+Repair/@28.6118325,-80.8098791,990m/data=!3m2!1e3!4b1!4m6!3m5!1s0x88e0a9e44650fd2f:0xe426ed43125ba47a",
  },
  {
    region: "Volusia",
    address: "1617 Ridgewood Ave Suite 211\nHolly Hill, FL 32117",
    phone: "(386) 204-7175",
    tel: "386-204-7175",
    mapUrl: "https://www.google.com/maps/place/Thomas+Roofing+%26+Repair/@29.0958227,-81.4083143,126094m/data=!3m2!1e3!4b1!4m6!3m5!1s0x657fb80c48dc93f1:0x29fae22bf68848fc",
  },
];

export default function Footer() {
  return (
    <footer className="bg-[#111111] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-10">
          {/* Brand */}
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center cursor-pointer mb-5">
              <img
                src="https://storage.readdy-site.link/project_files/f69dad05-caa6-4357-8060-5609c0454105/d6d7c484-28dd-4c76-8a75-b036f9196f61_ThomasLogo.svg?v=69187a6daa2100658c68583a79aaf4a8"
                alt="Thomas Roofing & Repair"
                className="h-14 w-auto object-contain"
                style={{ filter: "brightness(0) invert(1)" }}
              />
            </Link>
            <p className="text-white/55 font-body text-sm leading-relaxed mb-5 max-w-xs">
              Reliable roofing repairs &amp; replacements for Central Florida homeowners. Licensed #CCC1333138, insured, and trusted.
            </p>
            <div className="flex items-center gap-2 mb-5">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-mail-line text-[#10B981] text-sm"></i>
              </div>
              <a href="mailto:office@thomasroofs.com" className="text-white/60 hover:text-white font-body text-sm cursor-pointer transition-colors whitespace-nowrap">
                office@thomasroofs.com
              </a>
            </div>
            {/* Social links */}
            <div className="flex items-center gap-3">
              <a href="https://www.facebook.com/thomasroofs/" target="_blank" rel="nofollow noopener noreferrer" className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-[#10B981]/20 text-white/60 hover:text-[#10B981] transition-all cursor-pointer">
                <i className="ri-facebook-fill text-sm"></i>
              </a>
              <a href="https://www.instagram.com/thomasroofs/" target="_blank" rel="nofollow noopener noreferrer" className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-[#10B981]/20 text-white/60 hover:text-[#10B981] transition-all cursor-pointer">
                <i className="ri-instagram-line text-sm"></i>
              </a>
              <a href="https://www.youtube.com/channel/UC4-MFllq5YIEgi9h8UT9ZxQ" target="_blank" rel="nofollow noopener noreferrer" className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-[#10B981]/20 text-white/60 hover:text-[#10B981] transition-all cursor-pointer">
                <i className="ri-youtube-line text-sm"></i>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-headline font-700 text-white text-sm tracking-wider uppercase mb-5">
              Services
            </h4>
            <ul className="flex flex-col gap-2.5">
              {serviceLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-white/55 hover:text-[#10B981] font-body text-sm cursor-pointer transition-colors whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-headline font-700 text-white text-sm tracking-wider uppercase mb-5">
              Company
            </h4>
            <ul className="flex flex-col gap-2.5">
              {companyLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-white/55 hover:text-[#10B981] font-body text-sm cursor-pointer transition-colors whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Offices */}
          <div>
            <h4 className="font-headline font-700 text-white text-sm tracking-wider uppercase mb-5">
              Our Offices
            </h4>
            <div className="flex flex-col gap-5">
              {offices.map((office) => (
                <div key={office.region}>
                  <span className="text-[#10B981] font-body font-700 text-xs uppercase tracking-wider block mb-1.5">{office.region}</span>
                  <div className="flex items-start gap-2 mb-1">
                    <div className="w-4 h-4 flex items-center justify-center mt-0.5 shrink-0">
                      <i className="ri-map-pin-line text-white/40 text-xs"></i>
                    </div>
                    <a href={office.mapUrl} target="_blank" rel="nofollow noopener noreferrer" className="text-white/55 hover:text-white font-body text-xs leading-relaxed cursor-pointer transition-colors whitespace-pre-line">
                      {office.address}
                    </a>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="w-4 h-4 flex items-center justify-center shrink-0">
                      <i className="ri-phone-fill text-white/40 text-xs"></i>
                    </div>
                    <a href={`tel:${office.tel}`} className="text-white/55 hover:text-[#10B981] font-body text-xs cursor-pointer whitespace-nowrap transition-colors">
                      {office.phone}
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-6 flex flex-col lg:flex-row items-center justify-between gap-3">
          <p className="text-white/35 font-body text-xs">
            &copy; 2026 Thomas Roofing &amp; Repair Inc. All rights reserved. License #CCC1333138
          </p>
          <p className="text-white/35 font-body text-xs">
            Central Florida Roofing Contractor — Licensed &amp; Insured
          </p>
        </div>
      </div>
    </footer>
  );
}
